import React from 'react';
import { styled } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';
import { Box, TextField } from '@mui/material';
import { LoadingTypography } from 'lib/LoadingTypography';
import { useInputState } from 'lib/useInputState';
import { ButtonV2 } from '../ui/PayButton';

const PREFIX = 'PayGiftCardForm';

const classes = {
    body: `${PREFIX}body`,
    input: `${PREFIX}input`,
    textfield: `${PREFIX}textfield`
};

const StyledBox = styled(Box)(({ theme }) => ({
    [`& .${classes.body}`]: {
        fontSize: '24px',
        fontWeight: 700
    },

    [`& .${classes.input}`]: {
        padding: theme.spacing(1.5, 2)
    },

    [`& .${classes.textfield}`]: {
        margin: theme.spacing(3, 0, 0, 0)
    }
}));

interface PayGiftCardFormProps {
    onSubmit?: (value: string) => void;
    loading?: boolean;
}

export const PayGiftCardForm: React.FC<React.PropsWithChildren<PayGiftCardFormProps>> = ({
    onSubmit,
    loading
}) => {
    const { t } = useTranslation();

    const [value, onChange] = useInputState('');
    const handleSubmit = React.useCallback(() => {
        if (onSubmit) {
            onSubmit(value);
        }
    }, [value, onSubmit]);
    return (
        <StyledBox px={1} py={1.5}>
            <Box display="flex" flexDirection="column" alignItems="center">
                <LoadingTypography loading={loading} width={90} className={classes.body}>
                    {t('PAT_QUICKPAY_GIFTCARD_FORM_TITLE')}
                </LoadingTypography>
                <TextField
                    className={classes.textfield}
                    disabled={loading}
                    value={value}
                    onChange={onChange}
                    placeholder={t('CHECKOUT_GIFTCARD_ENTRY_TEXT')}
                    variant="outlined"
                    name="giftcard"
                    fullWidth
                    slotProps={{
                        input: {
                            autoComplete: 'off',
                            autoFocus: true
                        },

                        htmlInput: { className: classes.input }
                    }}
                />
                <ButtonV2 disabled={value.length === 0 || loading} onClick={handleSubmit}>
                    {t('CHECKOUT_GIFTCARD_APPLY_BTN')}
                </ButtonV2>
            </Box>
        </StyledBox>
    );
};
